

import { useState } from "react";
import Config from "../../Config";


import Start from "./Start";
import Contract from "./Contract";
import Invoice from "./Invoice";
import Transfer from "./Transfer";
import Calculate from "./Calculate";
import Saldo from "./Saldo";
import ReqPay from "./ReqPay";
import SaldoSum from "./SaldoSum";
import ReqPaySelect from "./ReqPaySelect";
import TransferOnline from "./TransferOnline";
import Ksef from "./Ksef";
 


 






function CalcView(props)
{

 
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);

 
 

    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);   
    }

    var tab1 = " m_item ";
    var tab2 = " m_item ";
    var tab3 = " m_item ";
    var tab4 = " m_item ";
    var tab5 = " m_item ";
    var tab6 = " m_item ";
    var tab7 = " m_item ";
    var tab8 = " m_item ";
    var tab9 = " m_item ";
    var tab10 = " m_item ";


    if(props.mainView.viewSelected == "start") tab1 = tab1 + " selected";
    if(props.mainView.viewSelected == "contract") tab2 = tab2 + " selected";
    if(props.mainView.viewSelected == "invoice") tab3 = tab3 + " selected";
    if(props.mainView.viewSelected == "transfer") tab4 = tab4 + " selected";
    if(props.mainView.viewSelected == "calculate") tab5 = tab5 + " selected";
    if(props.mainView.viewSelected == "saldo") tab6 = tab6 + " selected";
    if(props.mainView.viewSelected == "saldo_sum") tab7 = tab7 + " selected";
    if(props.mainView.viewSelected == "reqforpay") tab8 = tab8 + " selected";
    if(props.mainView.viewSelected == "online") tab9 = tab9 + " selected";
    if(props.mainView.viewSelected == "ksef") tab10 = tab10 + " selected";
 
 

    var subMenu = <div className="submenu">
            <div className={tab1} module="calc" view="start" id="" onClick={props.mainView.quickGo} >Ustawienia</div>
            <div className={tab2} module="calc" view="contract" id="" onClick={props.mainView.quickGo} >Umowy</div>
            <div className={tab3}  module="calc" view="invoice" id="" onClick={props.mainView.quickGo} >Rachunki i faktury</div> 
            <div className={tab4}  module="calc" view="transfer" id="" onClick={props.mainView.quickGo} >Przelewy i wpłaty</div> 
            <div className={tab9}  module="calc" view="online" id="" onClick={props.mainView.quickGo} >Przelewy OnLine</div> 
            <div className={tab5}  module="calc" view="calculate" id="" onClick={props.mainView.quickGo} >Rozliczenia</div> 
            <div className={tab6}  module="calc" view="saldo" id="" onClick={props.mainView.quickGo} >Historia salda</div> 
            <div className={tab7}  module="calc" view="saldo_sum" id="" onClick={props.mainView.quickGo} >Podsumowanie</div> 
            <div className={tab8}  module="calc" view="reqforpay" id="" onClick={props.mainView.quickGo} >Wezwania</div>         
            <div className={tab10}  module="calc" view="ksef" id="" onClick={props.mainView.quickGo} >KSeF</div>         
    </div>

 


    if(props.mainView.viewSelected == 'start' || props.mainView.viewSelected == undefined )
    {
        document.title ="Ustawienia / Rozliczenia"; 

        return (
            <div className="econtent ">    
               {subMenu}                                                                           
                  <Start  userData={props.userData}  mainView={props.mainView}  />    
             </div>
        )
    }


    if(props.mainView.viewSelected == 'contract'   )
        {
            document.title ="Umowy / Rozliczenia"; 
            return (
                <div className="econtent ">      
                   {subMenu}                                                         
                           <Contract  userData={props.userData}  mainView={props.mainView}  />    
                 </div>
            )
        }
    
 
        if(props.mainView.viewSelected == 'invoice'   )
            {
                document.title ="Rachunki i faktury / Rozliczenia"; 
                return (
                    <div className="econtent ">   
                       {subMenu}                                                            
                               <Invoice  userData={props.userData}  mainView={props.mainView}  />    
                     </div>
                )
            }
                      

            
        if(props.mainView.viewSelected == 'transfer'   )
            {
                document.title ="Przelewy / Rozliczenia"; 
                return (
                    <div className="econtent ">    
                       {subMenu}                                                           
                               <Transfer  userData={props.userData}  mainView={props.mainView}  />    
                     </div>
                )
            }

        if(props.mainView.viewSelected == 'calculate'   )
                {
                    document.title ="Rozliczenia / Rozliczenia"; 
                    return (
                        <div className="econtent ">    
                           {subMenu}                                                           
                                   <Calculate  userData={props.userData}  mainView={props.mainView}  />    
                         </div>
                    )
                }

        if(props.mainView.viewSelected == 'saldo'   )
                    {
                        document.title ="Saldo / Rozliczenia"; 
                        return (
                            <div className="econtent ">   
                               {subMenu}                                                            
                                       <Saldo  userData={props.userData}  mainView={props.mainView}  />    
                             </div>
                        )
                    }      


        if(props.mainView.viewSelected == 'saldo_sum'   )
                        {
                            document.title ="Podsumowanie / Rozliczenia"; 
                            return (
                                <div className="econtent "> 
                                   {subMenu}                                                              
                                           <SaldoSum  userData={props.userData}  mainView={props.mainView}  />    
                                 </div>
                            )
                        }   

                    
        if(props.mainView.viewSelected == 'reqforpay'   )
                        {
                            document.title ="Wezwania do zapłaty / Rozliczenia"; 
                            return (
                                <div className="econtent ">   
                                   {subMenu}                                                            
                                           <ReqPaySelect  userData={props.userData}  mainView={props.mainView}  />    
                                 </div>
                            )
                        }                          
                
                    
        if(props.mainView.viewSelected == 'online'   )
                            {
                                document.title ="Przelewy OnLine"; 
                                return (
                                    <div className="econtent ">   
                                       {subMenu}                                                            
                                               <TransferOnline  userData={props.userData}  mainView={props.mainView}  />    
                                     </div>
                                )
                            }    
                            
                            
                    
        if(props.mainView.viewSelected == 'ksef'   )
                            {
                                document.title ="KSeF"; 
                                return (
                                    <div className="econtent ">   
                                       {subMenu}                                                            
                                               <Ksef  userData={props.userData}  mainView={props.mainView}  />    
                                     </div>
                                )
                            }                               


    return (
        <div className="econtent ">
             { "View, op: " +  props.mainView.viewSelected}
        </div>
    );
    
}

export default CalcView ;